var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSec1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 10,
    fill: "#017A59"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2348_1753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.18 38.2825L36.3337 42.18V40.2313H27.0772L30.9747 36.3337H36.3337V34.385L42.18 38.2825ZM11 14.8975L16.8463 11V12.9488H26.1028L22.2053 16.8463H16.8463V18.795L11 14.8975ZM29.9808 11L11 29.9808L23.1992 42.18L42.18 23.1992L29.9808 11ZM13.7088 29.9808L29.9808 13.7088L39.4712 23.1992L23.1992 39.4712L13.7088 29.9808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1258 29.9809L17.7617 31.345L21.8346 35.4179L23.1987 34.0538L24.6408 35.3984L29.9804 29.9809C29.0766 30.8583 27.8639 31.345 26.6042 31.3357C25.3446 31.3264 24.1392 30.8219 23.2484 29.9312C22.3577 29.0404 21.8532 27.835 21.8439 26.5754C21.8346 25.3157 22.3213 24.103 23.1987 23.1992L17.7812 28.5388L19.1258 29.9809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3984 21.8546L31.3255 17.7817L29.9614 19.1459L28.5388 17.7817L23.1992 23.1993C24.103 22.3218 25.3157 21.8351 26.5754 21.8444C27.835 21.8537 29.0404 22.3583 29.9312 23.249C30.8219 24.1397 31.3264 25.3451 31.3357 26.6048C31.345 27.8644 30.8583 29.0771 29.9809 29.9809L35.3984 24.6413L34.0343 23.2772L35.3984 21.8546Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2348_1753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.18,
    height: 31.18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1);
export default __webpack_public_path__ + "static/media/sec1.1717c4d716a856a36e2954f8ca9a3a96.svg";
export { ForwardRef as ReactComponent };